import MiniHeader from './MiniHeader.jsx'

export default MiniHeader
